import React from "react";
import { string } from "prop-types";

const RightArrow = ({ arrowColor = "#34b8b5" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="6.828" height="10.828">
    <defs />
    <path
      fill="none"
      stroke={arrowColor}
      strokeLinecap="round"
      strokeWidth="2"
      d="M1.415 1.415l4 4-4 4"
      data-name="Path 29"
    />
  </svg>
);

RightArrow.propTypes = {
  arrowColor: string,
};

export default RightArrow;
